<div class="color-example">
  <div class="clr-row">
    <div class="clr-col-6 clr-col-md-3 clr-mt-24px">
      <h3 cds-text="subsection medium">Basic Type</h3>
      <div class="color-example-item-section" *ngFor="let item of colorType.basicType">
        <div class="color-example-item" [ngStyle]="{ '--color': item.color | cssVariable }"></div>
        <div class="color-example-item-text">{{ item.text }}</div>
      </div>
    </div>
    <div class="clr-col-6 clr-col-md-3 clr-mt-24px">
      <h3 cds-text="subsection medium">Links</h3>
      <div class="color-example-item-section" *ngFor="let item of colorType.links">
        <div class="color-example-item" [ngStyle]="{ '--color': item.color | cssVariable }"></div>
        <div class="color-example-item-text">{{ item.text }}</div>
      </div>
    </div>
  </div>
</div>
